import { ChevronDown } from 'lucide-react'
import { Button, DropdownMenu } from '../common'
import styles from './StudioAppShell.module.css'

export function ProductSwitcher({ products, value, onChange, compact = false }) {
  if (products.length <= 1) {
    return (
      <div className={styles.fixedProduct} aria-label="Product">
        <span className={styles.contextLabel}>Product</span>
        <span>{products[0]?.label || 'Studio'}</span>
      </div>
    )
  }

  const selectedProduct = products.find((product) => product.id === value) || products[0]
  const selectedLabel = selectedProduct?.label || 'Studio'

  return (
    <div className={`${styles.productSwitcher} ${compact ? styles.productSwitcherCompact : ''}`.trim()}>
      <span className={styles.contextLabel}>Product</span>
      <DropdownMenu
        align="start"
        variant="rich"
        selectionMode="single"
        triggerLabel="Product menu"
        trigger={(
          <Button
            variant="secondary"
            size={compact ? 'compact' : 'default'}
            className={styles.productMenuTrigger}
            aria-label={`Product: ${selectedLabel}`}
          >
            <span className={styles.productMenuLabel}>{selectedLabel}</span>
            <ChevronDown size={17} aria-hidden="true" />
          </Button>
        )}
        items={products.map((product) => ({
          key: product.id,
          label: product.label,
          description: product.description,
          selected: product.id === selectedProduct?.id,
          onSelect: () => onChange?.(product.id),
        }))}
      />
    </div>
  )
}
